import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Budget Locale"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/budgetLocale'} // non mi piace non sia sumfinancial
                filters={filterModel}
                format='currency'
                compactformat={true}
            />
            <KPI
                title="Budget Locale Eroso"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/budgetLocaleErodedStatic'}// non mi piace non sia sumfinancial
                filters={filterModel}
                format='currency'
                compactformat={false}
            />
            <KPI
                title="Budget Locale Rimanente"
                dataProviderName={'statisticsviews/item/sum/commercials/areaSource/budgetLocaleRemainingStatic'}// non mi piace non sia sumfinancial
                filters={filterModel}
                format='currency'
                compactformat={false}
            />
            
        </Box>
    )
}

export default KPISet;